export default __webpack_public_path__ + "static/media/mypic.41ad0a6f.jpg";